import script from "./Co2QuizAnswersField.vue?vue&type=script&lang=ts&setup=true"
export * from "./Co2QuizAnswersField.vue?vue&type=script&lang=ts&setup=true"

import "./Co2QuizAnswersField.vue?vue&type=style&index=0&id=733700aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-733700aa"]])

export default __exports__